<!-- <img src="../assets/images/icons/white-circle-icon.svg" style="width: 120px; height: 120px;">
  <p>hdhdhdhh</p> -->
  <div class="row imagesRowMargins">
    <div class="SnapShotItemCustom">
      <kendo-arcgauge class="ArcGauge customArcGauge" [value]="30" [colors]="colors">
    
        <kendo-arcgauge-scale [startAngle]="startAngle" [endAngle]="endAngle" [rangeSize]="rangeSize"
          [rangePlaceholderColor]="rangePlaceholderColor" [rangeLineCap]="rangeLineCap">
          <ng-template kendoArcGaugeCenterTemplate let-value="acc.SubscriptionEndOfLife_availablevalue" let-color="color">
            <!-- <div class="NewCircularChartsCenterValue" [style.color]="color">1</div> -->
            <div class="NewCircularChartsCenterValue">1</div>
            <div class="CircleBottomRightContentValue">1</div>
          </ng-template>
        </kendo-arcgauge-scale>
      </kendo-arcgauge>
      <div class="SnapShotItemContentCustom">Stock Quantities Per Stock ID/Name </div>
    </div>
    <div class="SnapShotItemCustom">
      <kendo-arcgauge class="ArcGauge customArcGauge" [value]="30" [colors]="colors">
        <kendo-arcgauge-scale [startAngle]="startAngle" [endAngle]="endAngle" [rangeSize]="rangeSize"
          [rangePlaceholderColor]="rangePlaceholderColor" [rangeLineCap]="rangeLineCap">
          <ng-template kendoArcGaugeCenterTemplate let-value="acc.SubscriptionEndOfLife_availablevalue" let-color="color">
            <div class="NewCircularChartsCenterValue">5</div>
            <div class="CircleBottomRightContentValue">190</div>
          </ng-template>
        </kendo-arcgauge-scale>
      </kendo-arcgauge>
      <div class="SnapShotItemContentCustom">Nbr of PO’s Per Model ID/Name</div>
    </div>
    <div class="SnapShotItemCustom">
      <kendo-arcgauge class="ArcGauge customArcGauge" [value]="51" [colors]="colors">
        <kendo-arcgauge-scale [startAngle]="startAngle" [endAngle]="endAngle" [rangeSize]="rangeSize"
          [rangePlaceholderColor]="rangePlaceholderColor" [rangeLineCap]="rangeLineCap">
          <ng-template kendoArcGaugeCenterTemplate let-value="acc.SubscriptionEndOfLife_availablevalue" let-color="color">
            <div class="NewCircularChartsCenterValue">2</div>
            <div class="CircleBottomRightContentValue">90</div>
          </ng-template>
        </kendo-arcgauge-scale>
      </kendo-arcgauge>
      <div class="SnapShotItemContentCustom">Nbr of Locations Of Model ID/Name</div>
    </div>
    <div class="SnapShotItemCustom">
      <kendo-arcgauge class="ArcGauge customArcGauge" [value]="76" [colors]="colors">
        <kendo-arcgauge-scale [startAngle]="startAngle" [endAngle]="endAngle" [rangeSize]="rangeSize"
          [rangePlaceholderColor]="rangePlaceholderColor" [rangeLineCap]="rangeLineCap">
          <ng-template kendoArcGaugeCenterTemplate let-value="acc.SubscriptionEndOfLife_availablevalue" let-color="color">
            <div class="NewCircularChartsCenterValue">7</div>
            <div class="CircleBottomRightContentValue">51</div>
          </ng-template>
        </kendo-arcgauge-scale>
      </kendo-arcgauge>
      <div class="SnapShotItemContentCustom">Stock Quantities Per Stock ID/Name </div>
    </div>
    </div>